import { render, staticRenderFns } from "./ArrobaMedellinFollows.html?vue&type=template&id=eb2e50cc&scoped=true&"
import script from "./ArrobaMedellinFollows.vue?vue&type=script&lang=js&"
export * from "./ArrobaMedellinFollows.vue?vue&type=script&lang=js&"
import style0 from "./ArrobaMedellinFollows.scss?vue&type=style&index=0&id=eb2e50cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2e50cc",
  null
  
)

export default component.exports